import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const ChannelBadge = ({ channel }) => {
    const { t } = useTranslation("models");
    const isWhatsApp = channel === "whatsapp";
    return (
        <Badge
            bg={isWhatsApp ? "green.100" : "brand.100"}
            borderColor={isWhatsApp ? "green.200" : "brand.200"}
            borderWidth={1}
            variant="subtle"
            fontSize="xs"
            px={3}
            py={0.5}
            borderRadius={6}
            color={isWhatsApp ? "green.700" : "brand.700"}
        >
            {isWhatsApp ? t("recruitmentDetailPage.channelWhatsapp") : t("recruitmentDetailPage.channelChat")}
        </Badge>
    );
};

export default ChannelBadge;
